(function () {
function isDesktopHover() {
return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
}

function clamp(n, min, max) {
return Math.max(min, Math.min(max, n));
}

function initCard(card) {
const media = card.querySelector("[data-ps-card]");
if (!media) return;

const img = media.querySelector("[data-ps-img]") || media.querySelector("img");
if (!img) return;

let images = [];
try {
images = JSON.parse(media.getAttribute("data-ps-images") || "[]");
} catch (e) {
images = [];
}
images = images.filter(Boolean);
if (images.length <= 1) return;

const btnPrev = media.querySelector("[data-ps-prev]");
const btnNext = media.querySelector("[data-ps-next]");
const progressEl = media.querySelector("[data-ps-progress]");

let index = parseInt(media.getAttribute("data-ps-index") || "0", 10);
if (Number.isNaN(index)) index = 0;
index = clamp(index, 0, images.length - 1);

function setProgress(i) {
if (!progressEl) return;
const pct = ((i + 1) / images.length) * 100;
media.style.setProperty("--ps-progress", pct.toFixed(2) + "%");
}

function setImage(i) {
index = clamp(i, 0, images.length - 1);
media.setAttribute("data-ps-index", String(index));

// swap image
img.setAttribute("src", images[index]);

// uppdatera srcset om du vill (valfritt). Vi låter srcset vara.
setProgress(index);
}

// init
setImage(index);

// Desktop arrows
function onPrev(e) {
e.preventDefault();
e.stopPropagation();
setImage(index - 1);
}
function onNext(e) {
e.preventDefault();
e.stopPropagation();
setImage(index + 1);
}

if (btnPrev) btnPrev.addEventListener("click", onPrev);
if (btnNext) btnNext.addEventListener("click", onNext);

// Mobile swipe (pointer events)
let startX = 0;
let startY = 0;
let dragging = false;

function onPointerDown(e) {
if (isDesktopHover()) return; // swipe behövs främst på mobil
dragging = true;
startX = e.clientX;
startY = e.clientY;
}

function onPointerMove(e) {
if (!dragging || isDesktopHover()) return;
// om man scrollar vertikalt – släpp swipe
const dx = e.clientX - startX;
const dy = e.clientY - startY;
if (Math.abs(dy) > 18 && Math.abs(dy) > Math.abs(dx)) {
dragging = false;
}
}

function onPointerUp(e) {
if (!dragging || isDesktopHover()) return;
dragging = false;

const dx = e.clientX - startX;
if (Math.abs(dx) < 35) return; // tröskel

if (dx < 0) setImage(index + 1);
else setImage(index - 1);
}

media.addEventListener("pointerdown", onPointerDown, { passive: true });
media.addEventListener("pointermove", onPointerMove, { passive: true });
media.addEventListener("pointerup", onPointerUp, { passive: true });
media.addEventListener("pointercancel", () => (dragging = false), { passive: true });
}

function initAll() {
document.querySelectorAll(".ps-card").forEach(initCard);
}

if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", initAll);
} else {
initAll();
}
})();